/* eslint-disable camelcase */

/**
 * @param {ProductVariantCollection} featuredProductVariant
 * @returns {boolean}
 */
const isConcealerFoundationProductVariantUtil = ({ featuredProductVariant }) => {
  return !!featuredProductVariant?.tags?.includes('Concealer')
}

export default isConcealerFoundationProductVariantUtil
